<div class="create-category">
  <mat-card-title class="mat-display-1">
    <span>Kategorie erstellen</span>
  </mat-card-title>
  <div class="form">
    <mat-card>
      <div mat-icon-button mat-card-avatar class="list">
        <a routerLink="/course-category/list"></a>
      </div>
      <mat-card-content>
        <div class="new-form">
          <form *ngIf="demokratiewerkstattCategoryForm" [formGroup]="demokratiewerkstattCategoryForm"
                (ngSubmit)="submitForm()">
            <div class="mb-2">
              <div class="title1">
                <span class="projName">Name</span>
                <div class="subtitle1">
                  <input class="inputTitle" formControlName="name" label="Ihr Name hier"
                         placeholder="Name">
                </div>
              </div>
              <span class="note">Mindestens 4 Zeichen</span>
            </div>
            <div class="mb-2">
              <div class="title1">
                <span class="projName">Beschreibung</span>
                <div class="subtitle1">
                                    <textarea class="inputTitle" formControlName="description" label="Ihr Name hier"
                                              placeholder="Beschreibung" cols="30" rows="10"></textarea>
                </div>
              </div>
              <span class="note">Mindestens 10 Zeichen</span>
            </div>
            <mat-card-actions>
              <button
                mat-raised-button
                color="primary"
                [disabled]="demokratiewerkstattCategoryForm.invalid">
                Speichern
              </button>
              <button
                mat-raised-button
                color="primary"
                (click)="cancelEdit()">
                Cancel
              </button>
            </mat-card-actions>
          </form>
        </div>
      </mat-card-content>
    </mat-card>
  </div>
</div>
